// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1joNw","selected":"Chip_selected__2we6o"};